import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import CustomLoader from './CustomLoader';

const errorFormSchema = {
  name: '',
  email: '',
  message: '',
};

const errorFormSchemaValidation = Yup.object().shape({
  name: Yup.string()
    .required('Required')
    .max(100, 'Name can not be more than 100 characters'),
  email: Yup.string()
    .required('Required')
    .email('Please provide a valid email.'),
  message: Yup.string()
    .required('Required')
    .min(20, 'Please provide enough information to regenerate issue.'),
});

export class ErrorForm extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleSubmit = values => {
    const path = window.location.pathname;
    const projectId = path.split(/[/]/)[2];
    values.projectUuid = projectId;
    this.props.actions.saveCrashReport(values);
  };

  render() {
    const { saveCrashReportPending } = this.props.common;
    return (
      <div className="row pb-2" style={{ textAlign: 'left' }}>
        <div className="col-2"></div>
        <div className="col-8">
          <Formik
            initialValues={errorFormSchema}
            validationSchema={errorFormSchemaValidation}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              this.handleSubmit(values);
              setSubmitting(false);
              resetForm();
            }}
          >
            {({ isSubmitting, errors }) => (
              <Form>
                <div className="form-group">
                  <label>Name*</label>
                  <Field
                    type="text"
                    name="name"
                    className="form-control form-control-sm"
                    placeholder="Name"
                  />
                  <ErrorMessage name="name">
                    {msg => <div style={{ color: 'red' }}>{msg}</div>}
                  </ErrorMessage>
                </div>
                <div className="form-group">
                  <label>Email*</label>
                  <Field
                    type="email"
                    name="email"
                    className="form-control form-control-sm"
                    placeholder="Email"
                  />
                  <ErrorMessage name="email">
                    {msg => <div style={{ color: 'red' }}>{msg}</div>}
                  </ErrorMessage>
                </div>
                <div className="form-group">
                  <label>What Happend ?*</label>
                  <Field
                    as="textarea"
                    rows={3}
                    name="message"
                    className="form-control form-control-sm"
                    placeholder="I cliked on the create page button. Or Cliked on the update event button..."
                  />
                  <ErrorMessage name="message">
                    {msg => <div style={{ color: 'red' }}>{msg}</div>}
                  </ErrorMessage>
                </div>
                <div className="row">
                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn-custom-blue btn-sm"
                      disabled={isSubmitting || saveCrashReportPending}
                    >
                      Submit{' '}
                      <CustomLoader
                        loading={saveCrashReportPending !== undefined && saveCrashReportPending}
                      />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <div className="col-2"></div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorForm);
